import { Outlet } from "react-router-dom";
import { VodsLayout } from "./style";
import { resetVods } from "../../../../../../store/features/vods/vods-slice";
import { useAppDispatch } from "../../../../../../store/config";
import { useEffect } from "react";

export const TechniqueVideos = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    return () => {
      dispatch(resetVods());
    };
  }, []);

  return (
    <VodsLayout>
      <Outlet />
    </VodsLayout>
  );
};
